<!--
// app/components/pages/region-home/GermanyBracket.vue
-->
<script setup lang="ts">
import { setAliasUrl } from "~/src/Shared/utils";

type Props = {
  showTitle?: boolean;
};

const localePath = useLocalePath();

defineProps<Props>();

const { data: imageUrl, error } = await useFetch("/api/cms/germany-bracket");
if (error.value) console.error(error.value);
</script>

<template>
  <section v-if="imageUrl" class="kql-w-container xl:px-0 grid grid-cols-1">
    <div :class="['md:p-4 rounded-lg lg:mt-0', { 'md:bg-gray-900': showTitle }]">
      <div>
        <div
          v-if="showTitle"
          class="flex text-gray-400 uppercase text-sm mb-2 justify-between items-end px-4 md:px-0"
        >
          <p>{{ $t("tables.banner.title") }}</p>
          <nuxt-link
            :to="
              localePath({
                name: `region-Tables`,
                params: { region: 'germany' },
              })
            "
            class="normal-case text-primary text-xs"
          >
            {{ $t("cards.stats.seeMore.link") }}
          </nuxt-link>
        </div>
        <hr v-if="showTitle" class="mx-4 md:mx-0" />

        <div :class="['overflow-x-scroll max-w-full hide-scrollbar px-4 md:px-0', { 'mt-4': showTitle }]">
          <nuxt-img
            :src="setAliasUrl(imageUrl)"
            :alt="$t('tables.banner.title')"
            class="min-w-[600px] md:max-h-none md:h-auto md:w-full"
            fit="outside"
            width="1920"
            height="1080"
            sizes="600px md:1200px lg:1440px"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
